module.exports = __webpack_public_path__ + "img/B5.3a2c1b96.png";